/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Form_Gps_Device_IdInputs */

const vi_vehicle_form_gps_device_id = /** @type {(inputs: Vehicle_Form_Gps_Device_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device ID`)
};

/**

* @param {Vehicle_Form_Gps_Device_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_form_gps_device_id = /** @type {((inputs?: Vehicle_Form_Gps_Device_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Form_Gps_Device_IdInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_form_gps_device_id(inputs)
});